import React from 'react';
import './pendingPositionsReport.scss';
import TextField from '@mui/material/TextField';
import CheckIcon from '../../../../Assets/images/svg/dar_check_icon.svg';
import CancelIcon from '../../../../Assets/images/svg/dar_cancel_icon.svg';
import editIcon from '../../../../Assets/images/svg/dar_edit_button.svg';
import PropTypes from 'prop-types';
import { PENDING_POSITIONS_REPORT } from '../../../../Constants/strings';

const AddEditPendingPositions = ({
  params,
  editingCell,
  editedValues,
  setEditedValues,
  errorMessages,
  setErrorMessages,
  handleEditClick,
  handleSaveEdit,
  handleCancelEdit,
  dateRange,
  snackbarOpen,
  hasAccess,
}) => {

  const handleInputChange = (event) => {
    const value = event.target.value;
    let errorMessage = '';

    if (value.trim() === '') {
      errorMessage = PENDING_POSITIONS_REPORT.CAN_NOT_EMPTY;
    } else if (!/^\d*$/.test(value.trim())) {
      errorMessage = PENDING_POSITIONS_REPORT.NUMERIC_VALUE_ALLOWED;
    }

    setEditedValues({
      ...editedValues,
      [params.field]: value,
    });

    setErrorMessages({
      ...errorMessages,
      [params.field]: errorMessage,
    });
  };

  const handleEdit = () => {
    if (!dateRange.startDate || !dateRange.endDate) {
      snackbarOpen('Please select date range', 'warning');
      return;
    }
    handleEditClick(params.row.id, params.field, params.value);
  };

  const handleSaveClick = () => {
    const value = editedValues[params.field];
    if (
      typeof value !== 'string'
      || !value.trim()
      || editingCell.rowId !== params.row.id
    ) {
      return;
    }
    handleSaveEdit(params.row.id, params.field);
  };

  const isEditing
  = editingCell.rowId === params.row.id && editingCell.field === params.field;

  if (params.row.id === 'Total') {
    return <div className="pending-position-display-cell">{params.value}</div>;
  }

  return isEditing ? (
    <div className="pending-position-editing-cell">
      <div className="pending-position-editing-cell-container">
        <div className="pending-position-editing-cell-inner">
          <TextField
            className="pending-position-text-box"
            value={editedValues[params.field] || ''}
            onChange={handleInputChange}
            size="small"
            error={Boolean(errorMessages[params.field])}
            style={{ marginBottom: '4px' }}
          />
          {errorMessages[params.field] && (
            <div className="error-message">
              {errorMessages[params.field]}
            </div>
          )}
        </div>
        <div className="pending-position-flex-align-center">
          <button
            onClick={handleSaveClick}
            className={`pending-position-save-icon ${
              typeof editedValues[params.field] !== 'string'
              || !editedValues[params.field]?.trim()
              || editingCell.rowId !== params.row.id
                ? 'disabled'
                : ''
            }`}
            aria-label="Save"
          >
            <img src={CheckIcon} alt="Save" />
          </button>
          <button
            onClick={handleCancelEdit}
            className="pending-position-cancel-icon"
            aria-label="Cancel"
          >
            <img src={CancelIcon} alt="Cancel" />
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className="pending-position-display-cell">
      <button
        disabled={!hasAccess('update')}
        onClick={handleEdit}
        className={`pending-position-edit-icon ${!hasAccess('update') ? 'disabled' : ''}`}
        aria-label="Edit"
      >
        <img src={editIcon} alt="Edit" />
      </button>
      {params.value}
    </div>
  );
};

AddEditPendingPositions.propTypes = {
  params: PropTypes.shape({
    row: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.any,
    }),
    field: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  editingCell: PropTypes.shape({
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    field: PropTypes.string,
  }).isRequired,
  editedValues: PropTypes.object.isRequired,
  setEditedValues: PropTypes.func.isRequired,
  errorMessages: PropTypes.object.isRequired,
  setErrorMessages: PropTypes.func.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleSaveEdit: PropTypes.func.isRequired,
  handleCancelEdit: PropTypes.func.isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  snackbarOpen: PropTypes.func.isRequired,
  hasAccess: PropTypes.func.isRequired,
};

export default AddEditPendingPositions;
